import Vue from 'vue'
import {
  Row,
  Col,
  Button,
  Form,
  FormItem,
  Input,
  InputNumber,
  CheckboxGroup,
  Checkbox,
  Radio,
  RadioGroup,
  Select,
  OptionGroup,
  Option,
  Switch,
  DatePicker,
  Upload,
  Table,
  TableColumn,
  Pagination,
  Loading,
  Message,
  MessageBox,
  Tree,
  Tabs,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Tooltip,
  Collapse,
  CollapseItem,
  Popconfirm,
  Popover,
  Divider,
  Image,
  Breadcrumb,
  BreadcrumbItem,
  Badge,
  Cascader,
  CascaderPanel,
  Drawer,
  Tag,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Loading)

Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.component(Button.name, Button)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Input.name, Input)
Vue.component(InputNumber.name, InputNumber)
Vue.component(CheckboxGroup.name, CheckboxGroup)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Radio.name, Radio)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(Select.name, Select)
Vue.component(OptionGroup.name, OptionGroup)
Vue.component(Option.name, Option)
Vue.component(Switch.name, Switch)
Vue.component(DatePicker.name, DatePicker)
Vue.component(Upload.name, Upload)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Pagination.name, Pagination)
Vue.component(Tree.name, Tree)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(Dropdown.name, Dropdown)
Vue.component(DropdownMenu.name, DropdownMenu)
Vue.component(DropdownItem.name, DropdownItem)
Vue.component(Dialog.name, Dialog)
Vue.component(Tooltip.name, Tooltip)
Vue.component(Collapse.name, Collapse)
Vue.component(CollapseItem.name, CollapseItem)
Vue.component(Popconfirm.name, Popconfirm)
Vue.component(Popover.name, Popover)
Vue.component(Divider.name, Divider)
Vue.component(Image.name, Image)
Vue.component(Breadcrumb.name, Breadcrumb)
Vue.component(BreadcrumbItem.name, BreadcrumbItem)
Vue.component(Badge.name, Badge)
Vue.component(Cascader.name, Cascader)
Vue.component(CascaderPanel.name, CascaderPanel)
Vue.component(Drawer.name, Drawer)
Vue.component(Tag.name, Tag)

Vue.prototype.$message = (function() {
  return {
    success: function(message, duration = 3000) {
      Message({
        message,
        type: 'success',
        duration: duration,
      })
    },
    error: function(message, duration = 3000) {
      Message({
        message,
        type: 'error',
        duration: duration,
      })
    },
    warning: function(message, duration = 3000) {
      Message({
        message,
        type: 'warning',
        duration: duration,
      })
    },
    info: function(message, duration = 3000) {
      Message({
        message,
        type: 'info',
        duration: duration,
      })
    },
    clear: function() {
      Message.closeAll()
    },
  }
})()

Vue.prototype.$confirm = MessageBox.confirm